import React, { useEffect, useState } from 'react';
import mixpanel from 'mixpanel-browser';

import { Button } from '@mui/material';

import { getGeneralSurveyQuestionField } from '../../../constants/Surveys/GeneralSurveyModalContent';

import {
  VALUE,
  MULTI_SELECT,
  QUESTIONS,
  PARTNERS,
  PRODUCT_SERVICE_TYPES,
  BACK,
  SKIP,
  SUBMIT,
} from '../../../constants/Surveys';

import './GeneralSurveyModalContent.css';

export const GeneralSurveyModalContent = ({ generalSurveyQuestions, label, handleContinue }) => {
  const { skipped, completed, ...GENERAL_SURVEY_QUESTIONS_LIST } = generalSurveyQuestions;
  const [currentObj, setCurrentObj] = useState(GENERAL_SURVEY_QUESTIONS_LIST);

  useEffect(() => {
    setCurrentObj(GENERAL_SURVEY_QUESTIONS_LIST);
  }, [label]);

  const handleChange = ({ value, question, surveyQuestionType, fieldType }) => {
    setCurrentObj((prevState) => {
      let curVal = value;

      if (fieldType === MULTI_SELECT) {
        curVal = { ...currentObj[surveyQuestionType][QUESTIONS][question].VALUE };

        if (curVal?.hasOwnProperty(value)) {
          delete curVal[value];
        } else {
          curVal[value] = value;
        }
      }

      mixpanel.track('Survey Questions Form', {
        survey_questions_type: label,
        fieldType,
        value: curVal,
        [surveyQuestionType]: {
          Questions: {
            ...prevState[surveyQuestionType][QUESTIONS],
            [question]: {
              ...prevState[surveyQuestionType][QUESTIONS][question],
              [VALUE]: curVal,
            },
          },
        },
      });

      return {
        ...prevState,
        [surveyQuestionType]: {
          Questions: {
            ...prevState[surveyQuestionType][QUESTIONS],
            [question]: {
              ...prevState[surveyQuestionType][QUESTIONS][question],
              [VALUE]: curVal,
            },
          },
        },
      };
    });
  };

  let count = 0;

  return (
    <>
      <div className="general-survey-modal-content-wrapper">
        {Object.keys(currentObj).map((surveyQuestionType) => {
          return Object.keys(currentObj[surveyQuestionType]?.Questions).map((question) => {
            const surveyQuestionField = getGeneralSurveyQuestionField({
              questionsObj: currentObj[surveyQuestionType].Questions,
              question,
              surveyQuestionType,
              handleChange,
            });
            const addOrShowCount = !PARTNERS[question] && !PRODUCT_SERVICE_TYPES[question];
            if (addOrShowCount) {
              count++;
            }
            return (
              <div
                key={question + ' ' + surveyQuestionType}
                className="general-survey-questions-wrapper"
              >
                <div className="general-survey-question">
                  {addOrShowCount && <div className="survey-question-number-wrapper">{count}.</div>}
                  <div>{question}</div>
                </div>
                {surveyQuestionField}
              </div>
            );
          });
        })}
      </div>
      <div className="buttons-row-wrapper">
        <Button
          sx={{
            backgroundColor: 'black',
            borderRadius: '10px',
            width: '110px',
            visibility: { xs: 'hidden' },
          }}
          variant="contained"
        >
          {BACK}
        </Button>
        <Button
          sx={{
            backgroundColor: 'black',
            borderRadius: '10px',
            width: '110px',
            visibility: { xs: 'hidden' },
          }}
          variant="contained"
        >
          {SKIP}
        </Button>
        <Button
          sx={{ backgroundColor: 'black', borderRadius: '10px', width: '110px' }}
          variant="contained"
          onClick={() => {
            handleContinue({ skipped: false, completed: true, currentObj, label });
          }}
        >
          {SUBMIT}
        </Button>
      </div>
    </>
  );
};
